import { useState } from 'react';

import { useLazyGetUsersByNicknameQuery } from '@services';

import { UserModel } from 'v2/types/UserModel';

export const useTelegramValidation = () => {
  const [isValidating, setIsValidating] = useState(false);
  const [getUsersByNickname] = useLazyGetUsersByNicknameQuery();

  const validateUsernames = async (usernames: string[]): Promise<UserModel[]> => {
    setIsValidating(true);

    try {
      if (usernames.length === 0) {
        return [];
      }

      const { result } = await getUsersByNickname({ nicknames: usernames, isStrictSearch: true }).unwrap();

      return result || [];
    } catch (error) {
      return [];
    } finally {
      setIsValidating(false);
    }
  };

  return {
    validateUsernames,
    isValidating,
  };
};
